import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=013322a1&scoped=true&"
import script from "./InfoCard.vue?vue&type=script&lang=ts&"
export * from "./InfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=013322a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013322a1",
  null
  
)

export default component.exports